module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-23c123e408eaa5d2cedea926f9faaa2a.webp";